module.exports = __webpack_public_path__ + "img/default.38db96e4.png";